export namespace KommunikationConfigTypes {
    export const SMTP_MANDANT_OPTIONS = 'kom-smtp';
    export const TROUBLE_TICKET_MANDANT_OPTIONS = 'kom-troubleticket';
    
}

